import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { FetchStaffRequestType, getMPStaffListAPI } from 'features/Enterprise/Account/services'
import {
  ReplenishmentV3QueryType,
  ReplenishmentV3TaskAssignStaffPayloadType,
} from 'features/SupplyOrder/@types/ReplenishmentV3'
import {
  getWarehouseLocationsAPI,
  GetWarehouseLocationsResponseType,
} from 'features/SupplyOrder/services/replenishment'
import {
  getReplenishmentTaskV3,
  putAssignReplenishmentStaff,
  putCancelReplenishmentTask,
} from 'features/SupplyOrder/services/replenishmentV3'
import { callErrorMsg } from 'helpers/errorMsg'

export const SLICE_NAME = 'REPLENISHMENT_LETDOWN'

export const fetchReplenishmentLetdownTask = createAsyncThunk(
  `${SLICE_NAME}/fetchReplenishmentLetdownTask`,
  async (params: ReplenishmentV3QueryType, { rejectWithValue }) => {
    try {
      const response = await getReplenishmentTaskV3(params)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const cancelReplenishmentLetdownTask = createAsyncThunk(
  `${SLICE_NAME}/cancelReplenishmentLetdownTask`,
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await putCancelReplenishmentTask(id)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetWarehouseLocations = createAsyncThunk(
  `${SLICE_NAME}/fetchGetWarehouseLocations`,
  async (_, { rejectWithValue, getState }) => {
    try {
      const {
        auth: { userData },
      } = getState() as StoreStateType

      const response = await getWarehouseLocationsAPI()

      const warehouseList: GetWarehouseLocationsResponseType = userData.isSuperAdmin
        ? response.data
        : response.data.filter((item) =>
            userData?.location_roles.some((auth) => item.location_id === auth.location_id),
          )

      return warehouseList
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchStaffList = createAsyncThunk(
  `${SLICE_NAME}/fetchStaffList`,
  async (params: Partial<FetchStaffRequestType>, { rejectWithValue }) => {
    const updatedParams = {
      location_types: ['WAREHOUSE'],
      location_ids: [],
      page_index: 1,
      page_size: 20,
      name: '',
      roles: [],
      module: {
        bank_account: true,
        department_location: true,
        staff_attributes: true,
        staff_vendor: true,
        termination_status: true,
        vehicle: true,
      },
      staff_ids: [],
      ...params,
    }
    try {
      const { data } = await getMPStaffListAPI(updatedParams)
      return data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const assignReplenishmentLetdownStaff = createAsyncThunk(
  `${SLICE_NAME}/assignReplenishmentLetdownStaff`,
  async (payload: ReplenishmentV3TaskAssignStaffPayloadType) => {
    try {
      const response = await putAssignReplenishmentStaff(payload.replenishment_task_id, payload)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return Promise.reject(SOMETHING_WHEN_WRONG)
    }
  },
)
